module.exports = __webpack_public_path__ + "5919b0ce6a123706853bd065825fcbf5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/snowboard.png
// module id = 2448
// module chunks = 0